<template>
  <div>
    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12" class="order-xl-1">
          <order-details></order-details>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import OrderDetails from "./Orders/OrderDetails.vue";
import EditProfileForm from "./UserProfile/EditProfileForm.vue";
import UserCard from "./UserProfile/UserCard.vue";

export default {
  components: {
    OrderDetails,
    EditProfileForm,
    UserCard
  },
  mounted() {
    //code
    //console.log("order id in detail " + this.$route.params.id);
  }
};
</script>
<style>
</style>